import createHistory from 'history/createHashHistory';

const history = createHistory();
export default history;



// WEBPACK FOOTER //
// ./src/history.js